import React, { useEffect } from 'react';
import DeviceInfo from 'react-native-device-info';

import { FeatureFlagsContext } from './context';
import { getClient } from './serviceClient';

export interface Props {
  sdkKey: string;
  pollIntervalSeconds: number;
  isUserSignedIn: boolean;
  userInfo?: {
    email: string;
  };
  children: React.ReactNode;
}

export const FeatureFlagsProvider: React.FC<Props> = ({
  sdkKey,
  pollIntervalSeconds,
  isUserSignedIn,
  userInfo,
  children,
}) => {
  const featureFlagsClient = getClient({ pollIntervalSeconds, sdkKey });
  // make sure to release all resources
  useEffect(() => () => featureFlagsClient.dispose(), [featureFlagsClient]);

  const providedValue = {
    getBoolean: (key: string, defaultValue: boolean, callback: (value: boolean) => void): void => {
      featureFlagsClient.getAllKeys((keys: string | string[]): void => {
        if (!keys.includes(key)) {
          // FF key does not exist, return default value
          return callback(defaultValue);
        }
      });
      if (isUserSignedIn && userInfo) {
        return featureFlagsClient.getValue(key, defaultValue, callback, {
          identifier: userInfo.email,
          email: userInfo.email,
        });
      }
      // Identifier is required so we pass in a common string however we cannot use the A/B testing.
      return featureFlagsClient.getValue(key, defaultValue, callback, {
        identifier: 'anonymous',
      });
    },
    getNumber: (key: string, defaultValue: number, callback: (value: number) => void): void => {
      if (isUserSignedIn && userInfo) {
        return featureFlagsClient.getValue(key, defaultValue, callback, {
          identifier: userInfo.email,
          email: userInfo.email,
        });
      }
      // Identifier is required so we pass in a common string however we cannot use the A/B testing.
      return featureFlagsClient.getValue(key, defaultValue, callback, {
        identifier: 'anonymous',
      });
    },
  };

  return <FeatureFlagsContext.Provider value={providedValue}>{children}</FeatureFlagsContext.Provider>;
};
